import { IUser } from '@/entity/service.interface'
import { localUserKey } from '@/entity/system.interface'
import { setUserInfoByLocal } from '@/store/wallet'
import { Dispatch } from '@reduxjs/toolkit'
import { useLayoutEffect } from 'react'

// 自动根据session获取用户信息
const useUserLogin = (dispatch: Dispatch) => {
  // get login session
  useLayoutEffect(() => {
    try {
      console.log('start transfer login session')
      const info = sessionStorage.getItem(localUserKey)
      if (info) {
        const user = JSON.parse(info) as IUser
        dispatch(setUserInfoByLocal(user))
      }
    } catch (e) {
      console.log('no save user session')
    }
  }, [])
}
export default useUserLogin
